import AxiosInterceptor from "api/interceptor";
import fx from "../../utils/fx";

const stock = new AxiosInterceptor();

export default {
  get(qstr = {}) {
    qstr = fx.urlQueryString(qstr, false);
    return stock.get("/stock?" + qstr);
  },
  getWarNum() {
    return stock.get("/stock/warning_number?");
  },
  setWarningStock(value) {
    return stock.put("/stock/warning_number", value);
  },
  updateStock(id, inputs) {
    return stock.put("/stock/" + id, inputs);
  },
  createInventory(body) {
    return stock.post("/inventory_export", body);
  },
  getAllInventory(qstr = {}) {
    qstr = fx.urlQueryString(qstr, false);
    return stock.get("/inventory_export?" + qstr);
  },
  updatePos(id, data) {
    return stock.put(`/inventory_export/${id}`, data);
  },
  getAllPurchaseOrder(qstr = {}) {
    qstr = fx.urlQueryString(qstr, false);
    return stock.get("/inventory_receipt?" + qstr);
  },
  getPurchaseDetail(id, qstr = {}) {
    qstr = fx.urlQueryString(qstr, false);
    return stock.get(`/inventory_receipt/${id}?` + qstr);
  },
  getPosDetail(id, qstr = {}) {
    qstr = fx.urlQueryString(qstr, false);
    return stock.get(`/inventory_export/${id}?` + qstr);
  },
  updatePurchase(id, data) {
    return stock.put(`/inventory_receipt/${id}`, data);
  },
  createReceipt(data) {
    return stock.post(`/inventory_receipt`, data);
  },
  approvePos(id) {
    return stock.put(`/inventory_export/${id}/approve`);
  },
  approvePurchase(id) {
    return stock.put(`/inventory_receipt/${id}/approve`);
  },
  updateAdjustment(inputs) {
    return stock.post("/stock", inputs);
  },
  getAllAdjustment(qstr = {}) {
    qstr = fx.urlQueryString(qstr, false);
    return stock.get("/stock/adjustment?" + qstr);
  }
};
